<div class="mat-elevation-z8">
    <br />
    <form [formGroup]="VOForm">
        <ng-container formArrayName="VORows">
            <table
                #table
                mat-table
                [dataSource]="productLocales"
                class="mat-elevation-z8"
            >
                <!-- Position Column -->
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef>description</th>
                    <td
                        mat-cell
                        *matCellDef="let element; let i = index"
                        [formGroup]="element"
                    >
                        @if (VOForm.get("VORows")?.value[i].isEditable) {
                            <span>
                                {{ VOForm.get("VORows")?.value[i].description }}
                            </span>
                        }

                        @if (!VOForm.get("VORows")?.value[i].isEditable) {
                            <mat-form-field
                                style="width: 100%"
                                [appearance]="
                                    VOForm.get('VORows')?.value[i].isEditable
                                        ? 'fill'
                                        : 'outline'
                                "
                            >
                                <textarea
                                    matInput
                                    type="text"
                                    formControlName="description"
                                    [readonly]="
                                        VOForm.get('VORows')?.value[i]
                                            .isEditable
                                    "
                                ></textarea>
                            </mat-form-field>
                        }</td
                ></ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef>title</th>
                    <td
                        mat-cell
                        *matCellDef="let element; let i = index"
                        [formGroup]="element"
                    >
                        @if (VOForm.get("VORows")?.value[i].isEditable) {
                            <span>
                                {{ VOForm.get("VORows")?.value[i].title }}
                            </span>
                        }

                        @if (!VOForm.get("VORows")?.value[i].isEditable) {
                            <mat-form-field
                                style="width: 70%"
                                [appearance]="
                                    VOForm.get('VORows')?.value[i].isEditable
                                        ? 'fill'
                                        : 'outline'
                                "
                            >
                                <input
                                    matInput
                                    type="text"
                                    formControlName="title"
                                    [readonly]="
                                        VOForm.get('VORows')?.value[i]
                                            .isEditable
                                    "
                                />
                            </mat-form-field>
                        }
                        <!-- </span> -->
                    </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="locale">
                    <th mat-header-cell *matHeaderCellDef>locale</th>
                    <td
                        mat-cell
                        *matCellDef="let element; let i = index"
                        [formGroup]="element"
                    >
                        <span>
                            {{ VOForm.get("VORows")?.value[i].locale }}
                        </span>
                        <!-- </span> -->
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td
                        mat-cell
                        *matCellDef="let element; let i = index"
                        [formGroup]="element"
                    >
                        @if (!VOForm.get("VORows")?.value[i].isEditable) {
                            <button
                                mat-icon-button
                                class="material-icons app-toolbar-menu save-button"
                                matTooltip="Save Changes"
                                color="primary"
                                (click)="SaveVO(VOForm, i)"
                            >
                                <mat-icon>check_circle</mat-icon>
                            </button>
                        }

                        @if (!VOForm.get("VORows")?.value[i].isEditable) {
                            <button
                                mat-icon-button
                                class="material-icons app-toolbar-menu cancel-button"
                                matTooltip="Cancel Changes"
                                color="warn"
                                (click)="CancelSVO(VOForm, i)"
                            >
                                <mat-icon>cancel</mat-icon>
                            </button>
                        }

                        @if (VOForm.get("VORows")?.value[i].isEditable) {
                            <button
                                mat-icon-button
                                class="material-icons app-toolbar-menu save-button"
                                matTooltip="Edit"
                                color="primary"
                                (click)="EditSVO(VOForm, i)"
                            >
                                <mat-icon>edit</mat-icon>
                            </button>
                        }
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                ></tr>
            </table>
        </ng-container>
    </form>
</div>
